import _ from "lodash";
import {
  Accordion,
  AccordionSummary,
  Alert,
  Avatar,
  Breadcrumbs,
  Button,
  Card,
  CardContent,
  Divider,
  Grid,
  Modal,
  Paper,
  Snackbar,
  Typography,
  useTheme,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useContext, useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { BsContainer, BsRow, BsCol } from "../../layouts/components";
import viewsTexts from "../../common/viewsTexts.json";
import {
  CardHeaderWidget,
  LoadingWidget,
  SaveAction,
  SnackBarsComponent,
  TextFieldWidgetSelectControllerStyled,
} from "../../components";
import { FiltersContext } from "../../context";
import { AxiosContext } from "../../context/AxiosContext";
import Subtitle from "components/TailwindComponents/Subtitle";

// import { ButtonBox } from '../../components/Dashboard';

const useStyles = makeStyles((theme) => ({
  tableAreaStyle: {
    maxHeight: "370px",
    overflow: "auto",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paperContainerStyle: {
    padding: 20,
    marginBottom: 15,
  },
  dashCard: {
    minHeight: "100%",
  },
  dividerRow: {
    marginTop: 30,
  },
  theadLight: {
    "& th": {
      // color: '#495057',
      backgroundColor: theme.palette.grey[200],
      borderColor: theme.palette.grey[300],
    },
  },
}));

const CacheWhatsapp = () => {
  const axiosContext = useContext(AxiosContext);
  const {
    state: { userOrchard_filter, orchard_filter, orchard_id_filter },
    addFilter,
  } = useContext(FiltersContext);

  const [loadingDataState, setLoadingDataState] = useState(false);
  const [responseDataState, setResponseDataState] = useState(null);
  const [snackDataState, setSnackDataState] = useState(false);

  const getCacheWhatsappAsync = async () => {
    setLoadingDataState(true);
    setResponseDataState(null);
    try {
      let response = await axiosContext.authAxios.post(
        "v1/mongo/clear-data-set-types"
      );
      const { data, status } = response;
      console.log(data, "<<----respo Data Cache");

      if (status === 200) {
        setSnackDataState(true);
        setResponseDataState(data);
        setLoadingDataState(false);
      }
    } catch (error) {
      console.log(error);
      setLoadingDataState(false);
      // setLoadingVarietyFilterState(false);
    }
  };

  const handleCloseSnackBarsComponent = () => {
    setSnackDataState(false);
  };

  return (
    <div className="form-style">
      <div className="container">
        <Card elevation={0}>
          <CardContent>
            <Subtitle>{viewsTexts.titles.cacheWhatsapp.title}</Subtitle>
            <p className="text-sm text-primaryTheme mt-1 ml-1">
              Limpieza de dataset de registros con error para colección
              DataTypesCollectionError y WhatsApp, para evitar que se repitan
              los registros.
            </p>
            <Divider />
            <Button
              className="mt-4"
              variant="contained"
              color="secondary"
              onClick={getCacheWhatsappAsync}
              disabled={loadingDataState}
            >
              Limpiar DataSet
            </Button>
            {loadingDataState && <LoadingWidget />}
            {/* {responseDataState && <Alert severity="info">DESCARGUE AQUÍ</Alert>} */}
            <Snackbar
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              open={snackDataState}
              onClose={() => setSnackDataState(false)}
              autoHideDuration={3000}
              key={Math.random()}
            >
              <SnackBarsComponent
                variant="success"
                message={responseDataState}
                handleClose={handleCloseSnackBarsComponent}
              />
            </Snackbar>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default CacheWhatsapp;
